module.exports = __webpack_public_path__ + "img/20191018162529817.9c93e60a.jpg";